/**
 * Shared WAF-bypass path list for AI-agent discovery surfaces.
 *
 * These are the merchant-domain paths the Sill Worker and WordPress
 * plugin publish. If a WAF returns 403 to an anonymous AI crawler,
 * exempting these paths restores every discovery signal — the single
 * source of truth so the dashboard banner
 * (`apps/dashboard/src/components/WAFBlockBanner.tsx`), the hosted
 * report page (`apps/marketing/src/pages/ReportPage.tsx`), and the
 * readiness-report email template
 * (`services/api/src/email/templates/readiness-report.ts`) all list the
 * same set.
 *
 * Mirrors the paths handled by the generated Cloudflare Worker +
 * WordPress plugin in `services/api/src/http/routes/v1/agent-ready-downloads.ts`
 * — a merchant exempting this exact list will see every signal come
 * through the firewall. `/mcp` is intentionally absent — the real MCP
 * discovery path on a merchant domain is `/.well-known/mcp/server-card.json`
 * (the edge's `/v1/mcp/{site_key}` surface lives on `edge.sill.so`, not
 * the merchant's domain, so a merchant-WAF rule for `/mcp` would have
 * no effect).
 */
export const WAF_BYPASS_PATHS = [
    '/.well-known/agent-card.json',
    '/.well-known/mcp/server-card.json',
    '/.well-known/api-catalog',
    '/.well-known/ucp',
    '/.well-known/sill-proof.txt',
    '/llms.txt',
    '/agent',
    '/ai-catalog.json',
];
//# sourceMappingURL=waf-bypass-paths.js.map